import { createFileRoute } from '@tanstack/react-router'
import { useQuery } from '@tanstack/react-query'
import ReactMarkdown from 'react-markdown'
import remarkBreaks from 'remark-breaks'
import { Card, CardContent } from '~/client/components/ui/card'
import { activeAgreementsQuery } from '~/client/agreement/agreement.queries'
import { AGREEMENT_TYPE_LABELS } from '~/shared/agreement/agreement.constants'

export const Route = createFileRoute('/legal/customer-agreement')({
  component: RouteComponent,
})

function RouteComponent() {
  const { data, isLoading, error } = useQuery(activeAgreementsQuery())

  const customer = data?.find((v) => v.type === 'customer_agreement')

  return (
    <div className="bg-muted min-h-svh py-10 px-4">
      <div className="mx-auto max-w-3xl">
        <Card>
          <CardContent className="p-8">
            <h1 className="text-2xl font-semibold mb-2">{AGREEMENT_TYPE_LABELS.customer_agreement}</h1>
            {customer?.version_date && (
              <p className="text-sm text-gray-500 mb-6">
                Last updated {customer.version_date.toFormat('LLLL d, yyyy')}
              </p>
            )}

            {isLoading && (
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <div className="h-4 w-4 animate-spin rounded-full border-2 border-[#8A3DFF] border-t-transparent" />
                Loading agreement...
              </div>
            )}

            {error && (
              <p className="text-sm text-destructive">
                Failed to load the agreement. Please try again later.
              </p>
            )}

            {!isLoading && !error && !customer && (
              <p className="text-sm text-gray-600">No agreement is currently published.</p>
            )}

            {customer?.markdown_content && (
              <article className="prose prose-sm max-w-none">
                {/*
                  Markdown comes from the DB; disable dangerous embeds.
                  `rehype-sanitize` isn't installed, so we drop the unsafe
                  element set directly. `unwrapDisallowed` keeps any inner
                  text so the document stays readable.
                */}
                <ReactMarkdown
                  remarkPlugins={[remarkBreaks]}
                  disallowedElements={['script', 'iframe', 'style', 'object', 'embed']}
                  unwrapDisallowed
                >
                  {customer.markdown_content}
                </ReactMarkdown>
              </article>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
